import { useCallback } from "react";

import MarkNotificationAsReadFailureToast from "../components/MarkNotificationAsReadFailureToastContent";
import useDispatchDangerToast from "../../../shared/hooks/toasts/useDispatchDangerToast";

type DispatchMarkNotificationAsReadToast = {
  dispatchFailureToast: () => void;
};

export default useDispatchMarkNotificationAsReadToast;

function useDispatchMarkNotificationAsReadToast(): DispatchMarkNotificationAsReadToast {
  const _dispatchDangerToast = useDispatchDangerToast();
  const dispatchFailureToast = useCallback(() => {
    _dispatchDangerToast({ content: <MarkNotificationAsReadFailureToast /> });
  }, [_dispatchDangerToast]);

  return {
    dispatchFailureToast,
  };
}
